// extracted by mini-css-extract-plugin
export default {"root":"Photography_root__5yoPO","wrapper":"Photography_wrapper__15OaT","image":"Photography_image__PWEob","card":"Photography_card__5flqp"};